import { groupBy } from 'lodash'
import momentTimezone from 'moment-timezone'
import formatTimestamp from '@app/utils/time-formatter'
import { isCurrentYear } from '@app/utils/date-formatter'

const formatDate = (datetime) => {
  const format = isCurrentYear(datetime) ? 'D MMMM' : 'D MMMM YYYY'
  return formatTimestamp(datetime, { shouldUseLocalTimezone: true, format })
}

const groupAuditsPerDay = ({ audits, timestampGetter }) =>
  groupBy(audits, (audit) => {
    const timestamp = timestampGetter(audit)

    return formatDate(momentTimezone(timestamp))
  })

export default groupAuditsPerDay
